import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, toHandlers as _toHandlers, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["data-cy"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon");
  const _component_mf_notifications_badge = _resolveComponent("mf-notifications-badge");
  return _openBlock(), _createElementBlock("div", {
    class: "icon-wrapper",
    onClick: _cache[4] || (_cache[4] = $event => _ctx.$emit('click', $event))
  }, [$options.isIconFromMfIcons ? (_openBlock(), _createBlock(_component_svg_icon, {
    key: 0,
    attrs: $props.attrs,
    class: "mf-icon",
    "data-cy": $props.dataCy,
    icon: $options.getIcon,
    on: $props.on,
    size: $options.getSize,
    onMouseleave: _cache[0] || (_cache[0] = $event => _ctx.$emit('mouseleave', $event)),
    onMouseover: _cache[1] || (_cache[1] = $event => _ctx.$emit('mouseover', $event))
  }, null, 8, ["attrs", "data-cy", "icon", "on", "size"])) : (_openBlock(), _createElementBlock("span", _mergeProps({
    key: 1,
    "data-testid": "material-symbols-icon",
    class: `material-symbols-${$props.variant} mf-icon`,
    "data-cy": $props.dataCy,
    style: $options.getMaterialDesignStyle
  }, $props.attrs, _toHandlers($props.on, true), {
    onMouseleave: _cache[2] || (_cache[2] = $event => _ctx.$emit('mouseleave', $event)),
    onMouseover: _cache[3] || (_cache[3] = $event => _ctx.$emit('mouseover', $event))
  }), _toDisplayString($options.getIcon), 17, _hoisted_1)), $props.showNotification ? (_openBlock(), _createBlock(_component_mf_notifications_badge, {
    key: 2,
    class: "notifications-badge-absolute",
    "notifications-counter": $props.notificationsCounter,
    size: $props.notificationBadgeSize
  }, null, 8, ["notifications-counter", "size"])) : _createCommentVNode("", true)]);
}